export default __webpack_public_path__ + "static/media/double-arrow.3bc0e712.svg";